import SockJS from 'sockjs-client';


const sockService = {
  getSock: function (baseUrl) {
    return new SockJS(`${baseUrl}/ws`);
  },
};


export default sockService;

